import React from 'react';
import { APP_CONTAINER_ROUTES } from '@/navigators/routes';
import { AppContainerStackParams } from '@/navigators/types';
import { CreditMemoDetailComponent } from './credit-memo-detail-component';
import { StackScreenProps } from '@react-navigation/stack';

type Props = StackScreenProps<
  AppContainerStackParams,
  APP_CONTAINER_ROUTES.CreditMemoDetail
>;

export const CreditMemoDetailScreen: React.FC<Props> = ({ route }) => {
  const { creditMemoUUID } = route.params;

  return <CreditMemoDetailComponent creditMemoUUID={creditMemoUUID} />;
};
